import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { MembershipItemFragment } from '@occc/graphql';
import { usePaginationParams } from '@occc-app/hooks/usePaginationParams';
import { useSearchParams } from '@occc-app/hooks/useSearchParams';
import { useIsUserPermittedTo, Feature } from '@occc/utils-access-control';

import { MemberListPage } from './MemberListPage';

import { routeCreator } from '../utils';

export const MemberListPageContainer = () => {
  const isUserPermittedToViewAllowList = useIsUserPermittedTo(Feature.ALLOW_LIST_VIEW);

  const navigate = useNavigate();
  const [paginationInfo, onPageChange] = usePaginationParams();
  const [membersSearch, setMembersSearch] = useSearchParams();

  const onClickMember = useCallback(
    (member: MembershipItemFragment) => {
      navigate(routeCreator.details(member.id));
    },
    [navigate],
  );

  return (
    <MemberListPage
      membersFilterText={membersSearch}
      onMembersSearchFormSubmit={({ search }) => setMembersSearch(search)}
      onClickMember={onClickMember}
      paginationInfo={paginationInfo}
      onPageChange={onPageChange}
      isUserPermittedToViewAllowList={isUserPermittedToViewAllowList}
    />
  );
};
